
export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-purple-900 via-purple-700 to-blue-600"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 left-10 w-2 h-2 bg-white rounded-full animate-pulse"></div>
        <div className="absolute top-40 right-20 w-1 h-1 bg-white rounded-full animate-pulse delay-100"></div>
        <div className="absolute bottom-32 left-1/4 w-1.5 h-1.5 bg-white rounded-full animate-pulse delay-200"></div>
        <div className="absolute top-1/3 right-1/3 w-1 h-1 bg-white rounded-full animate-pulse delay-300"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          <div className="flex-1 text-center lg:text-left w-full">
            <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <i className="ri-shield-check-line text-white w-5 h-5 flex items-center justify-center"></i>
              <span className="text-white text-sm font-medium whitespace-nowrap">Enterprise VPN Solution</span>
            </div>

            <h1 className="text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight">
              Secure Your<br />Digital<br />Privacy
            </h1>

            <p className="text-lg text-white/90 mb-8 max-w-xl">
              DINARCO provides cutting-edge VPN technology to protect your online presence. Experience military-grade encryption, lightning-fast connections, and complete anonymity across all your devices.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <button
                onClick={() => scrollToSection('contact')}
                className="px-8 py-4 bg-black text-white rounded-lg font-medium hover:bg-gray-900 transition-all whitespace-nowrap cursor-pointer"
              >
                Get Started
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="px-8 py-4 bg-transparent text-white border-2 border-white rounded-lg font-medium hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
              >
                Learn More
              </button>
            </div>
          </div>

          <div className="flex-1 relative w-full">
            <div className="relative w-full h-96">
              <img
                src="https://public.readdy.ai/ai/img_res/95f837b1ec191160da8380c23eec8ade.jpg"
                alt="VPN Security Illustration"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
